// ─────────────────────────────────────────────
// KLOTHIQ — Central Brand Configuration
// ─────────────────────────────────────────────
// Single source of truth for branding, logo, contact info,
// and default settings used across PDF receipts and exports.

import { BRAND_TAGLINE } from '@klothiq/domain';

export interface BrandConfig {
  name: string;
  tagline: string;
  logoPath: string; // Relative URL to logo image in public folder
  website: string;
  email: string;
  phone: string;
  address: string;
  cityStateZip: string;
  gstin?: string;
  currencySymbol: string;
  currencyCode: string;
  receiptFooterMessage: string;
  reportFooterMessage: string;
  primaryColorHex: string; // e.g. '#1e293b'
  secondaryColorHex: string; // e.g. '#475569'
}

export const brandConfig: BrandConfig = {
  name: 'Klothiq',
  tagline: BRAND_TAGLINE,
  logoPath: '/logo.png', // Actual logo file at public/logo.png
  website: 'www.klothiq.com',
  email: 'klothiq@gmail.com',
  phone: '+91 81390 55870',
  address: 'Darmasala',
  cityStateZip: 'Kannur, Kerala',
  gstin: undefined, // Set to real GSTIN once confirmed
  currencySymbol: '₹',
  currencyCode: 'INR',
  receiptFooterMessage: 'Thank you for shopping with Klothiq!',
  reportFooterMessage: `Generated from Klothiq Admin — ${BRAND_TAGLINE}`,
  primaryColorHex: '#06B6D4',   // Teal brand color
  secondaryColorHex: '#0891B2', // Teal-700
};

/**
 * Returns a high-contrast SVG/data-URI logo fallback when real image file is loading or missing.
 */
export function getBrandLogoCanvasDataUrl(): string {
  if (typeof document === 'undefined') return '';
  const canvas = document.createElement('canvas');
  canvas.width = 300;
  canvas.height = 100;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  // Background badge — teal brand
  ctx.fillStyle = '#06B6D4'; // Klothiq Teal
  ctx.beginPath();
  ctx.roundRect(10, 10, 280, 80, 12);
  ctx.fill();

  // Accent line — white
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(20, 20, 4, 60);

  // Brand Name
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 34px sans-serif';
  ctx.fillText(brandConfig.name, 40, 58);

  // Subtitle
  ctx.fillStyle = 'rgba(255,255,255,0.75)';
  ctx.font = '12px sans-serif';
  ctx.fillText(brandConfig.tagline, 42, 76);

  return canvas.toDataURL('image/png');
}
